import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import ModalVideo from 'react-modal-video'
import 'photoswipe/dist/photoswipe.css'
import { Gallery, Item } from 'react-photoswipe-gallery'
import Seo from '../../components/common/Seo'
import Header3 from '../../components/header/header-rslhome'
import Overview from '../../components/hotel-single/Overview'
import { Swiper, SwiperSlide } from 'swiper/react'
import AdditionalInformation from '../../components/hotel-single/AdditionalActivities'
import PopularFacilities from '../../components/hotel-single/PopularFacilities'
import PropertyHighlights from '../../components/hotel-single/PropertyHighlightsActivity'
import SidebarRight from '../../components/activities/side-nave'
import Facilities from '../../components/hotel-single/FacilitiesActivity'
import Facilities1 from '../../components/hotel-single/FacilitiesActivity1'
import CallToActions from '../../components/common/CallToActions'
import { useMediaQuery } from 'react-responsive'
import { Navigation, Autoplay } from 'swiper'
import DefaultFooter from '../../components/footer/footer-3'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Card,
  CardMedia,
  Box,
  Skeleton,
  Grid,
  Divider
} from '@mui/material'
import GoogleMap from '../../components/activities/googleMap'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import RelatedProducts from '../../components/destinations/RelatedProducts'

// Redux
import { useDispatch, useSelector } from '../../redux/store'
import { getHotelList, activityDetails } from '../../redux/slices/activity'
import { fetchSeoByPage } from '../../lib/seoHelper'

const HotelSingleV1Dynamic = ({ meta }) => {
  const dispatch = useDispatch()

  const { activityDetailsRes } = useSelector(state => state.activity)
  const [open, setOpen] = useState(false)
  const [multiImage, setMultiImage] = useState([])
  const router = useRouter();
  const [activityData, setActivityData] = useState({})
  const [loader, setLoader] = useState(true)
  const [expanded, setExpanded] = useState([])
  const apiKey = process.env.MAPKEY;
  const { _id, id, city, checkIn, checkOut } = router.query
  const isMobileOrTablet = useMediaQuery({ maxWidth: 1024 })
  const [photoIndex, setPhotoIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  const [imageSize, setImageSize] = useState({ width: 1000, height: 1000 })

  const [isSticky, setIsSticky] = useState(false)

  const latitude = 25.2325885
  const longitude = 55.5559354
  const name = 'Your Activity Name'

  // useEffect(() => {
  //   const loadMapScript = () => {
  //     const script = document.createElement("script");
  //     script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap`;
  //     script.async = true;
  //     script.defer = true;
  //     document.head.appendChild(script);

  //     script.onload = initMap;
  //   };

  //   const initMap = () => {
  //     const map = new window.google.maps.Map(document.getElementById("map"), {
  //       center: { lat: latitude, lng: longitude },
  //       zoom: 15,
  //     });

  //     new window.google.maps.Marker({
  //       position: { lat: latitude, lng: longitude },
  //       map: map,
  //       title: "Your Marker Title",
  //     });
  //   };

  //   loadMapScript();
  // }, [apiKey, latitude, longitude]);

  // const id = router.query.id;

  const cardMediaStyle = {
    width: '100%',
    height: 'auto'
  }

  const photos = [
    { url: 'https://via.placeholder.com/150', title: 'Image 1' },
    { url: 'https://via.placeholder.com/150', title: 'Image 2' },
    { url: 'https://via.placeholder.com/150', title: 'Image 3' },
    { url: 'https://via.placeholder.com/150', title: 'Image 4' }
  ]

  useEffect(() => {
    dispatch(activityDetails({ activityId: id || _id }))
  }, [router.query])

  useEffect(() => {
    if (activityDetailsRes) {
      setLoader(true)
      if (Object.keys(activityDetailsRes).length === 0) {
      } else {
        setActivityData(activityDetailsRes)
        setMultiImage(activityDetailsRes?.backgroundImage)
        setLoader(false)
      }
    }
    return () => { }
  }, [activityDetailsRes])

  const handleToggle = index => {
    setExpanded(prevExpanded => {
      const newExpanded = [...prevExpanded]
      newExpanded[index] = !newExpanded[index]
      return newExpanded
    })
  }

  const handleOpen = index => {
    // console.log("index", index);
    setPhotoIndex(index)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  const handleNext = () => {
    setPhotoIndex((photoIndex + 1) % multiImage.length) // Loop to first image after last
  }

  const handlePrev = () => {
    // console.log("photoIndex", photoIndex);
    setPhotoIndex((photoIndex + multiImage.length - 1) % multiImage.length) // Loop to last image before first
  }

  // 🔹 Get image dimensions dynamically
  const handleImageLoad = event => {
    setImageSize({
      width: event.target.naturalWidth,
      height: event.target.naturalHeight
    })
  }

  return (
    <>
      {/* <ModalVideo
        channel="youtube"
        autoplay
        isOpen={open}
        videoId="oqNZOOWF8qM"
        onClose={() => setOpen(false)}
      /> */}

      <Seo meta={meta} />
      {/* End Page Title */}

      <div className='header-margin'></div>
      {/* header top margin */}

      <Header3 bgColor="#f6f6f6" borderColor="#DFDFDF" />
      {/* End Header 1 */}

      <section className='pt-60 mt-60' id='gallery'>
        <div className='container'>
          {loader ?
            <div className='d-flex justify-content-between'>
              <div style={{ width: "80%" }}>
                <Skeleton variant="text" width="100%" height={40} />
                <Skeleton variant="text" width="100%" height={150} />
              </div>
              <div>
                <Skeleton variant="text" width={120} height={30} />
                <Skeleton variant="rectangular" width={120} height={20} />
              </div>
            </div>
            :
            <div className='row y-gap-20 justify-between justify-content-md-start items-center'>
              <div className='col-12 col-md-8'>
                <div className='row x-gap-20  items-center'>
                  <div className='col-auto'>
                    <h1 className='text-30 sm:text-25 fw-600'>
                      {activityData?.name}
                    </h1>
                  </div>
                </div>

                <div className='row x-gap-20 y-gap-20 items-center'>
                  <div className='col-auto'>
                    <div className='d-flex items-center text-15 text-light-1'>
                      {activityData?.description}
                    </div>
                  </div>
                </div>
              </div>

              <div className='col-12 col-md-4'>
                <div className='col items-start'>
                  <div className='col-auto justify-content-end align-items-start align-items-md-end d-flex flex-column'>
                    <div className='text-14 text-dark-1 text-secondary'>
                      From
                      <span className='text-26 px-2 text-dark-1 fw-600'>
                        {activityData?.currency} {activityData?.startingPrice}
                      </span>
                      <div>
                        {Array.from(
                          {
                            length:
                              activityData?.rating > 5 ? 5 : activityData?.rating
                          },
                          (_, index) => (
                            <i
                              key={index}
                              className='icon-star text-10 text-yellow-1'
                            />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
          {loader ? (
            <Gallery>
              <div className='galleryGrid -type-1 pt-30'>
                <div className='galleryGrid__item relative d-flex'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width={500}
                    height={460}
                  />
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width={325}
                    height={225}
                  />
                </div>

                <div className='galleryGrid__item'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width={325}
                    height={225}
                  />
                </div>

                <div className='galleryGrid__item'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width={325}
                    height={225}
                  />
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item relative d-flex'>
                  <Skeleton
                    animation='wave'
                    variant='rectangular'
                    width={325}
                    height={225}
                  />
                </div>
                {/* End .galleryGrid__item */}
              </div>
            </Gallery>
          ) : isMobileOrTablet ? (
            <Swiper
              spaceBetween={10}
              slidesPerView={1}
              autoplay={true}
              modules={[Navigation, Autoplay]}
              navigation={{
                nextEl: '.js-destination-next',
                prevEl: '.js-destination-prev'
              }}
            >
              {multiImage.map((image, index) => (
                <SwiperSlide key={index}>
                  {image ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${image}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${image}`}
                      width={imageSize.width}
                      height={imageSize.height}
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={() => handleOpen(index)}
                          src={`${process.env.IMAGE_BASE_URL}/${image}`}
                          alt={`image-${index}`}
                          className='rounded-4'
                          style={{ width: '100%', height: '100%' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    <Skeleton variant='rect' width='100%' height={310} />
                  )}
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <Gallery>
              <div className='galleryGrid -type-1 pt-30'>
                <div className='galleryGrid__item relative d-flex'>
                  {multiImage[0] ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${multiImage[0]}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[0]}`}
                      className='rounded-4'
                      width={imageSize.width} // ✅ Dynamically set width
                      height={imageSize.height} // ✅ Dynamically set height
                    // style={{
                    //   width: '200px',
                    //   height: '100px'
                    // }}
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={open}
                          src={`${process.env.IMAGE_BASE_URL}/${multiImage[0]}`}
                          alt='image'
                          className='rounded-4'
                          style={{ width: '660px', height: '460px' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    <Skeleton variant='rect' width={500} height={310} />
                  )}
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item relative'>
                  {multiImage[1] ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${multiImage[1]}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[1]}`}
                      width={imageSize.width} // ✅ Dynamically set width
                      height={imageSize.height} // ✅ Dynamically set height
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={open}
                          src={`${process.env.IMAGE_BASE_URL}/${multiImage[1]}`}
                          alt='image'
                          className='rounded-4'
                          style={{ width: '325px', height: '225px' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={280} height={150} />
                  )}
                </div>

                <div className='galleryGrid__item relative'>
                  {multiImage[2] ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${multiImage[2]}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[2]}`}
                      width={imageSize.width} // ✅ Dynamically set width
                      height={imageSize.height} // ✅ Dynamically set height
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={open}
                          src={`${process.env.IMAGE_BASE_URL}/${multiImage[2]}`}
                          alt='image'
                          className='rounded-4'
                          style={{ width: '325px', height: '225px' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={280} height={150} />
                  )}
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item relative'>
                  {multiImage[3] ? (
                    <Item
                      original={`${process.env.IMAGE_BASE_URL}/${multiImage[3]}`}
                      thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[3]}`}
                      width={imageSize.width} // ✅ Dynamically set width
                      height={imageSize.height} // ✅ Dynamically set height
                    >
                      {({ ref, open }) => (
                        <img
                          ref={ref}
                          onClick={open}
                          src={`${process.env.IMAGE_BASE_URL}/${multiImage[3]}`}
                          alt='image'
                          className='rounded-4'
                          style={{ width: '325px', height: '225px' }}
                          role='button'
                          onLoad={handleImageLoad}
                        />
                      )}
                    </Item>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={280} height={150} />
                  )}
                </div>
                {/* End .galleryGrid__item */}

                <div className='galleryGrid__item relative d-flex'>
                  {multiImage[4] ? (
                    <>
                      <Item
                        original={`${process.env.IMAGE_BASE_URL}/${multiImage[4]}`}
                        thumbnail={`${process.env.IMAGE_BASE_URL}/${multiImage[4]}`}
                        width={imageSize.width} // ✅ Dynamically set width
                        height={imageSize.height} // ✅ Dynamically set height
                      >
                        {({ ref, open }) => (
                          <img
                            ref={ref}
                            onClick={open}
                            src={`${process.env.IMAGE_BASE_URL}/${multiImage[4]}`}
                            alt='image'
                            className='rounded-4'
                            style={{ width: '325px', height: '225px' }}
                            role='button'
                            onLoad={handleImageLoad}
                          />
                        )}
                      </Item>
                    </>
                  ) : (
                    /* Render MUI Skeleton Loader here when no image is available */
                    <Skeleton variant='rect' width={280} height={150} />
                  )}
                </div>
                {/* End .galleryGrid__item */}
              </div>
            </Gallery>
          )}

          {isOpen && (
            <div
              className='model'
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
              }}
            >
              <div
                className='model-content'
                style={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'none'
                }}
              >
                {/* Left navigation button */}
                <button
                  onClick={handlePrev}
                  className='buttonStyles'
                  style={{
                    border: 'none',
                    color: '#fff',
                    fontSize: '36px',
                    padding: '10px',
                    cursor: 'pointer',
                    position: 'absolute',
                    left: '-50px'
                  }}
                >
                  &lt;
                </button>

                {/* Image in the middle */}
                <img
                  src={`${process.env.IMAGE_BASE_URL}/${multiImage[photoIndex]}`}
                  alt={`image-${photoIndex}`}
                  style={{
                    maxWidth: '80%',
                    maxHeight: '80%',
                    backgroundColor: 'none',
                    borderRadius: '10px'
                  }}
                />

                {/* Right navigation button */}
                <button
                  onClick={handleNext}
                  className='buttonStyles'
                  style={{
                    border: 'none',
                    color: '#fff',
                    fontSize: '36px',
                    padding: '10px',
                    cursor: 'pointer',
                    position: 'absolute',
                    right: '-50px'
                  }}
                >
                  &gt;
                </button>
              </div>

              {/* Close button */}
              <span
                className='close'
                onClick={handleClose}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  fontSize: '36px',
                  color: '#fff',
                  cursor: 'pointer'
                }}
              >
                &times;
              </span>
            </div>
          )}
        </div>
        {/* End .container */}
      </section>
      {/* End gallery grid wrapper */}

      <Box className='container pt-30 pb-60' id='sidebar'>
        <Box className='row'>
          <Box component='div' className='col-xl-8'>
            <section className='pt-0'
            // style={{ minHeight: '100vh' }}
            >
              <section className='' id='facilities'>
                <div className='container'>
                  <div className='row x-gap-40 y-gap-40'>
                    <div className='col-12 px-1'>
                      {activityData?.activityDescription &&
                        activityData?.activityDescription !== '' ? (
                        <>
                          <h4 className='text-22 fw-700 mb-20'>Details</h4>
                          <Overview
                            hotelDescription={activityData?.activityDescription}
                          />
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                </div>
              </section>

              {activityData?.length !== 0 && activityData?.benefits > 0 ? (
                <section className='' id='facilities'>
                  <div className='container'>
                    <div className='row x-gap-20 y-gap-40'>
                      <div className='col-12 px-1'>
                        <div className='row x-gap-40 y-gap-40 pt-20'>
                          <Facilities facility={activityData?.benefits} />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              ) : (
                ''
              )}

              {/* {activityData?.length !== 0 ? (
                <section className='' id='facilities'>
                  <div className='container'>
                    <div className='row x-gap-20 y-gap-40'>
                      <div className='col-12'>
                        <div className='row x-gap-40 y-gap-40 pt-20'>
                          <Facilities1 facility={activityData?.tags} />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              ) : (
                ''
              )} */}

              {activityData?.additionalInformation?.length !== 0 ? (
                <section className='' id='facilities'>
                  <div className='container'>
                    <div className='row x-gap-20 y-gap-20'>
                      <div className='col-12'>
                        {activityData?.additionalInformation && (
                          <div id='overview' className='col-12'>
                            <AdditionalInformation
                              hotelDescription={
                                activityData?.additionalInformation
                              }
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              ) : (
                ''
              )}

              {activityData?.detailInfo?.filter(
                item =>
                  item.title.trim() !== '' && item.description.trim() !== ''
              ).length > 0 ? (
                <section className='' id='facilities'>
                  <div className='container'>
                    <div className='row x-gap-40 y-gap-40'>
                      <div className='col-12 px-1'>
                        <h4 className='text-22 fw-700'>
                          {activityData?.detailInfoTitle}
                        </h4>
                        {activityData?.detailInfo
                          .filter(
                            item =>
                              item.title.trim() !== '' &&
                              item.description.trim() !== ''
                          )
                          .map((item, index) => (
                            <Accordion
                              defaultExpanded={index === 0}
                              key={item.id}
                              sx={{
                                boxShadow: 'none',
                                borderWidth: '0',
                                '&.Mui-expanded': {
                                  margin: '0px !important'
                                }
                              }}
                            >
                              <AccordionSummary
                                sx={{
                                  padding: '0px'
                                }}
                                expandIcon={<ExpandMoreIcon />}
                              >
                                <h6 className='py-1 text-dark'>{item.title}</h6>
                              </AccordionSummary>
                              <AccordionDetails>
                                <div
                                  className='ql-editor'
                                  dangerouslySetInnerHTML={{
                                    __html: item.description
                                  }}
                                />
                              </AccordionDetails>
                            </Accordion>
                          ))}
                      </div>
                    </div>
                  </div>
                </section>
              ) : null}

              {activityData?.latitude &&
                activityData?.longitude &&
                activityData?.latitude > 0 &&
                activityData?.longitude > 0 ? (
                <section className='' id='facilities'>
                  <div className='container'>
                    <div className='row x-gap-40 y-gap-40'>
                      <div className='col-12 px-1'>
                        <h4 className='text-22 fw-700 mb-20'>Location</h4>
                        <GoogleMap
                          apiKey={apiKey}
                          name={activityData?.name}
                          latitude={activityData?.latitude}
                          longitude={activityData?.longitude}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              ) : (
                ''
              )}
            </section>
          </Box>
          <Box
            component='div'
            className='col-xl-4 col-sm-12 py-2 sticky-sidebar position-static scrollbar-width-none'
          >
            <SidebarRight activityData={activityData} />
          </Box>
        </Box>
      </Box>

      <section className='container'>
        <div className='col-auto'>
          <Divider
            sx={{
              borderColor: 'grey !important'
            }}
          />
        </div>
      </section>

      <section className='layout-pb-md sm-px-3'>
        <div className='container'>
          <div className='col-auto'>
            <div className='sectionTitle -md'>
              <h2 className='rsl_title'>Related Activities</h2>
              <p className='sub-header'>
                Explore top attractions and adventure experiences.
              </p>
            </div>
          </div>

          <div className='row y-gap-30 pt-20'>
            <div
              className='relative'
              style={{
                overflow: 'hidden'
              }}
            >
              <RelatedProducts serviceType={6} type={activityData?.type} />
            </div>
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>

      <CallToActions />

      <DefaultFooter />
    </>
  )
}

// export default dynamic(() => Promise.resolve(HotelSingleV1Dynamic), {
//   ssr: false
// })

export default HotelSingleV1Dynamic;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}